import { createContext, type Context } from 'react';

const contexts = new Map<string, Context<unknown>>();

/** Lazy pages may keep the previous provider across a Vite update. Keep its context identity. */
export function createStableContext<T>(name: string, initial: T): Context<T> {
  if (!import.meta.hot) return createContext(initial);
  const existing = contexts.get(name);
  if (existing) return existing as Context<T>;
  const context = createContext(initial);
  contexts.set(name, context as Context<unknown>);
  return context;
}
